// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3LkRz","range":"MonthRangeSwitch_range__3d6MG","disabled":"MonthRangeSwitch_disabled__1k9R4"};